module.exports = __webpack_public_path__ + "static/verdesPorUnDia-5c178e5702a5817aa1ceb9d5e799fecd.png";